// import { Input, Select } from 'antd';
import { Input, Select } from 'antd';
import * as PropTypes from 'prop-types';
import React from 'react';
const FilterInputs = {
  string: ({ values, onChange }) => (
    <Select
      key='input'
      style={{
        width: 300,
      }}
      mode='tags'
      onChange={onChange}
      value={values}
    />
  ),
  number: ({ values, onChange }) => (
    <Input
      key='input'
      style={{
        width: 300,
      }}
      onChange={(e) => onChange([e.target.value])}
      value={(values && values[0]) || ''}
    />
  ),
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
FilterInputs.string.propTypes = {
  values: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
FilterInputs.string.defaultProps = {
  values: [],
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
FilterInputs.number.propTypes = {
  values: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
FilterInputs.number.defaultProps = {
  values: [],
};

const FilterInput = ({ member, updateMethods }) => {
  const Filter = FilterInputs[member.dimension.type] || FilterInputs.string;
  return (
    <Filter
      key='filter'
      values={member.values}
      onChange={(values) => updateMethods.update(member, { ...member, values })}
    />
  );
};

FilterInput.propTypes = {
  member: PropTypes.object.isRequired,
  updateMethods: PropTypes.object.isRequired,
};
export default FilterInput;
